import React from 'react';

const Footer = () => (
  <footer className="footer" data-testid="site-footer">
    <div className="footer-content" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0.6rem' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '0.85rem', flexWrap: 'wrap', justifyContent: 'center' }}>
        <img src="/livrum-logo-light.webp" alt="Livrum" data-testid="footer-logo"
          style={{ height: '26px', width: 'auto', filter: 'brightness(0) invert(1)' }} />
        <span aria-hidden="true" style={{ color: 'rgba(255,255,255,0.35)' }}>|</span>
        <a href="mailto:contato@livrum.com.br" data-testid="footer-email" style={{ color: 'rgba(255,255,255,0.85)', textDecoration: 'none', fontSize: '0.875rem' }}>
          contato@livrum.com.br
        </a>
      </div>
      <div className="footer-copyright" data-testid="footer-copyright" style={{ color: 'rgba(255,255,255,0.6)', fontSize: '0.875rem', fontWeight: 400 }}>
        Livrum - Copyright © 2026. Todos os direitos reservados.
      </div>
    </div>
  </footer>
);

export default Footer;
